import React from "react";
import { Box } from "@mui/material";
import ProductCardSkeleton from "../ProductCardSkeleton/ProductCardSkeleton";
import { PRODUCT_GRID_SX } from "../PublicList/PublicList";

/**
 * Enough to fill the first screen and no more: eight is two rows of four on desktop and four rows
 * of two on a phone.
 *
 * Deliberately not `PAGE_SIZE` (48). The skeleton should say "results are coming", not pretend to
 * know how many — and 48 placeholder cards would make an empty search look, for a moment, like a
 * very successful one.
 */
const SKELETON_CARDS = 8;

const PLACEHOLDERS = Array.from({ length: SKELETON_CARDS }, (_, i) => i);

/**
 * The catalog grid's loading state (EB-543).
 *
 * Replaces a centred spinner that left the grid area empty, so the whole page below jumped when
 * the first batch arrived.
 */
const ProductGridSkeleton: React.FC = () => (
  <Box sx={PRODUCT_GRID_SX} data-testid="product-grid-skeleton" aria-busy>
    {PLACEHOLDERS.map((key) => (
      <ProductCardSkeleton key={key} />
    ))}
  </Box>
);

export default ProductGridSkeleton;
